import { render, staticRenderFns } from "./DeleteServiceProviderModal.vue?vue&type=template&id=72bdc6cd&"
import script from "./DeleteServiceProviderModal.vue?vue&type=script&lang=js&"
export * from "./DeleteServiceProviderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports